module.exports = __webpack_public_path__ + "static/media/bg-mobilefull-d1.c7e2d437.png";